var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectX2Text(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 123,
    viewBox: "0 0 151 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_200_342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 62,
    r: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 62,
    r: 39.546,
    stroke: "#D6DCE5",
    strokeWidth: 0.908091
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7463 57.1735H82.5426V49.4785L82.4798 49.3923H49.7367L49.6074 49.4784V71.7615C49.6074 72.4754 50.1861 73.0541 50.9 73.0541H67.7464V57.1735H67.7463Z",
    fill: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7463 70.7455H49.6074V71.7615C49.6074 72.4753 50.1861 73.0539 50.9 73.0539H67.7464V70.7455H67.7463Z",
    fill: "#D8ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5425 57.1734V49.4783L82.4797 49.3922H80.0747V57.1734H82.5425Z",
    fill: "#D8ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2502 44.1805H50.8999C50.1861 44.1805 49.6074 44.7591 49.6074 45.4729V49.4784H82.5426V45.4729C82.5426 44.7591 81.964 44.1805 81.2502 44.1805Z",
    fill: "#FFC333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2502 44.1805H80.0749V46.36C80.0749 46.8073 79.7123 47.17 79.265 47.17H49.6074V49.4784H82.5426V45.4729C82.5426 44.7591 81.964 44.1805 81.2502 44.1805Z",
    fill: "#FFE8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6655 57.0923H88.0445V77.4713H67.6655V57.0923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6593 57.0923V74.2573C85.6593 74.7046 85.2967 75.0672 84.8493 75.0672H67.6655V77.4713H88.0445V57.0923H85.6593Z",
    fill: "#F8F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9013 79.2895H66.4294C66.1079 79.2895 65.8472 79.0288 65.8472 78.7073V76.2354C65.8472 75.9139 66.1079 75.6531 66.4294 75.6531H68.9013C69.2228 75.6531 69.4836 75.9139 69.4836 76.2354V78.7073C69.4836 79.0288 69.2229 79.2895 68.9013 79.2895Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2261 78.7073V76.2354C86.2261 75.9139 86.4868 75.6531 86.8084 75.6531H89.2802C89.6017 75.6531 89.8625 75.9139 89.8625 76.2354V78.7073C89.8625 79.0288 89.6017 79.2895 89.2802 79.2895H86.8084C86.4867 79.2895 86.2261 79.0288 86.2261 78.7073Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9013 58.9106H66.4294C66.1079 58.9106 65.8472 58.6498 65.8472 58.3283V55.8565C65.8472 55.5349 66.1079 55.2742 66.4294 55.2742H68.9013C69.2228 55.2742 69.4836 55.5349 69.4836 55.8565V58.3283C69.4836 58.6499 69.2229 58.9106 68.9013 58.9106Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2261 58.3283V55.8565C86.2261 55.5349 86.4868 55.2742 86.8084 55.2742H89.2802C89.6017 55.2742 89.8625 55.5349 89.8625 55.8565V58.3283C89.8625 58.6498 89.6017 58.9106 89.2802 58.9106H86.8084C86.4867 58.9106 86.2261 58.6499 86.2261 58.3283Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4501 73.5886H73.2591C72.314 73.5886 71.5479 72.8225 71.5479 71.8774V62.6863C71.5479 61.7412 72.314 60.975 73.2591 60.975H82.4502C83.3953 60.975 84.1615 61.7412 84.1615 62.6863V71.8774C84.1615 72.8224 83.3952 73.5886 82.4501 73.5886Z",
    fill: "#33B8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4502 60.975H81.7815V69.9748C81.7815 70.6457 81.2375 71.1897 80.5665 71.1897H71.5479V71.8773C71.5479 72.8224 72.314 73.5886 73.2591 73.5886H82.4502C83.3953 73.5886 84.1615 72.8224 84.1615 71.8773V62.6863C84.1615 61.7412 83.3953 60.975 82.4502 60.975Z",
    fill: "#26A6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1255 47.4369C75.4611 47.4369 75.733 47.165 75.733 46.8295C75.733 46.4939 75.4611 46.222 75.1255 46.222H75.0372C74.7016 46.222 74.4297 46.4939 74.4297 46.8295C74.4297 47.165 74.7016 47.4369 75.0372 47.4369H75.1255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5097 47.4369C77.8453 47.4369 78.1172 47.165 78.1172 46.8295C78.1172 46.4939 77.8453 46.222 77.5097 46.222H77.4214C77.0859 46.222 76.814 46.4939 76.814 46.8295C76.814 47.165 77.0859 47.4369 77.4214 47.4369H77.5097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8936 47.4369C80.2292 47.4369 80.5011 47.165 80.5011 46.8295C80.5011 46.4939 80.2292 46.222 79.8936 46.222H79.8052C79.4697 46.222 79.1978 46.4939 79.1978 46.8295C79.1978 47.165 79.4697 47.4369 79.8052 47.4369H79.8936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8581 66.0178C81.1937 66.0178 81.4656 65.7459 81.4656 65.4103V64.2786C81.4656 63.943 81.1937 63.6711 80.8581 63.6711H74.8516C74.516 63.6711 74.2441 63.943 74.2441 64.2786V65.4103C74.2441 65.7459 74.516 66.0178 74.8516 66.0178C75.1872 66.0178 75.4591 65.7459 75.4591 65.4103V64.8861H77.2474V69.6776H76.7667C76.4311 69.6776 76.1592 69.9495 76.1592 70.285C76.1592 70.6206 76.4311 70.8925 76.7667 70.8925H78.943C79.2785 70.8925 79.5504 70.6206 79.5504 70.285C79.5504 69.9495 79.2785 69.6776 78.943 69.6776H78.4623V64.8861H80.2506V65.4103C80.2507 65.7459 80.5226 66.0178 80.8581 66.0178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0252 54.9197H56.9224C56.5868 54.9197 56.3149 55.1916 56.3149 55.5271C56.3149 55.8627 56.5868 56.1346 56.9224 56.1346H62.0252C62.3607 56.1346 62.6326 55.8627 62.6326 55.5271C62.6326 55.1916 62.3607 54.9197 62.0252 54.9197Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9688 56.1346H54.852C55.1876 56.1346 55.4595 55.8627 55.4595 55.5271C55.4595 55.1916 55.1876 54.9197 54.852 54.9197H52.9688C52.6332 54.9197 52.3613 55.1916 52.3613 55.5271C52.3613 55.8627 52.6332 56.1346 52.9688 56.1346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0251 58.2665H52.9688C52.6332 58.2665 52.3613 58.5384 52.3613 58.874C52.3613 59.2095 52.6332 59.4814 52.9688 59.4814H62.0251C62.3606 59.4814 62.6325 59.2095 62.6325 58.874C62.6325 58.5384 62.3605 58.2665 62.0251 58.2665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0251 61.6133H52.9688C52.6332 61.6133 52.3613 61.8852 52.3613 62.2208C52.3613 62.5564 52.6332 62.8283 52.9688 62.8283H62.0251C62.3606 62.8283 62.6325 62.5564 62.6325 62.2208C62.6325 61.8852 62.3605 61.6133 62.0251 61.6133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0251 64.9602H52.9688C52.6332 64.9602 52.3613 65.2321 52.3613 65.5677C52.3613 65.9032 52.6332 66.1751 52.9688 66.1751H62.0251C62.3606 66.1751 62.6325 65.9032 62.6325 65.5677C62.6325 65.2321 62.3605 64.9602 62.0251 64.9602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2803 59.5181C89.9363 59.5181 90.47 58.9844 90.47 58.3284V55.8565C90.47 55.2004 89.9362 54.6668 89.2803 54.6668H86.8084C86.1523 54.6668 85.6187 55.2005 85.6187 55.8565V56.485H83.1501V45.473C83.1501 44.4253 82.2979 43.573 81.2502 43.573H59.2865C58.9509 43.573 58.679 43.8449 58.679 44.1805C58.679 44.516 58.9509 44.7879 59.2865 44.7879H81.2502C81.6279 44.7879 81.9352 45.0952 81.9352 45.473V48.8709H50.2149V45.473C50.2149 45.0952 50.5222 44.7879 50.8999 44.7879H56.4516C56.7872 44.7879 57.0591 44.516 57.0591 44.1805C57.0591 43.8449 56.7872 43.573 56.4516 43.573H50.8999C49.8522 43.573 49 44.4253 49 45.473V71.7615C49 72.8092 49.8522 73.6614 50.8999 73.6614H67.0579V75.0456H66.4295C65.7734 75.0456 65.2397 75.5794 65.2397 76.2354V78.7072C65.2397 79.3633 65.7735 79.897 66.4295 79.897H68.9013C69.5574 79.897 70.0911 79.3632 70.0911 78.7072V78.0788H85.6186V78.7072C85.6186 79.3633 86.1523 79.897 86.8083 79.897H89.2802C89.9362 79.897 90.4699 79.3632 90.4699 78.7072V76.2354C90.4699 75.5793 89.9362 75.0456 89.2802 75.0456H88.6517V59.5181H89.2803ZM86.8336 55.8816H89.2551V58.3031H86.8336V55.8816ZM68.8761 78.682H66.4547V76.2606H68.8761V78.682ZM89.2551 78.682H86.8336V76.2606H89.2551V78.682ZM87.4369 75.0456H86.8084C86.1523 75.0456 85.6187 75.5794 85.6187 76.2354V76.8638H70.0911V76.2354C70.0911 75.5793 69.5573 75.0456 68.9013 75.0456H68.2729V69.7536C68.2729 69.418 68.001 69.1461 67.6654 69.1461C67.3298 69.1461 67.0579 69.418 67.0579 69.7536V72.4465H50.8999C50.5222 72.4465 50.2149 72.1392 50.2149 71.7615V50.0858H81.9352V56.485H70.0911V55.8565C70.0911 55.2004 69.5574 54.6668 68.9014 54.6668H66.4296C65.7735 54.6668 65.2398 55.2005 65.2398 55.8565V58.3284C65.2398 58.9844 65.7736 59.5181 66.4296 59.5181H67.058V66.9187C67.058 67.2543 67.3299 67.5262 67.6655 67.5262C68.001 67.5262 68.2729 67.2543 68.2729 66.9187V59.5181H68.9014C69.5575 59.5181 70.0911 58.9844 70.0911 58.3284V57.6999H85.6187V58.3284C85.6187 58.9844 86.1524 59.5181 86.8084 59.5181H87.4369V75.0456ZM66.4547 58.3031V55.8816H68.8761V58.3031H66.4547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4501 60.3676H80.8313C80.4957 60.3676 80.2238 60.6395 80.2238 60.975C80.2238 61.3106 80.4957 61.5825 80.8313 61.5825H82.4501C83.0588 61.5825 83.554 62.0777 83.554 62.6864V71.8774C83.554 72.4861 83.0588 72.9812 82.4501 72.9812H73.2592C72.6505 72.9812 72.1554 72.4861 72.1554 71.8774V62.6864C72.1554 62.0777 72.6505 61.5825 73.2592 61.5825H77.9964C78.332 61.5825 78.6039 61.3106 78.6039 60.975C78.6039 60.6395 78.332 60.3676 77.9964 60.3676H73.2592C71.9807 60.3676 70.9404 61.4078 70.9404 62.6864V71.8774C70.9404 73.1559 71.9807 74.1962 73.2592 74.1962H82.4502C83.7287 74.1962 84.769 73.1559 84.769 71.8774V62.6864C84.7689 61.4078 83.7287 60.3676 82.4501 60.3676Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_200_342",
    x: -1.78318,
    y: -4.33464,
    width: 152.647,
    height: 152.647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54045,
    dy: 9.989
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1618
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.130044 0 0 0 0 0.396943 0 0 0 0 0.687863 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_200_342"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_200_342",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.47,
    height: 41.47,
    fill: "white",
    transform: "translate(49 41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectX2Text);
export default __webpack_public_path__ + "static/media/connect_x2text.c486679d28dca2b312ba7532503079d0.svg";
export { ForwardRef as ReactComponent };